import React, { useState } from 'react';
import './SkillsMarquee.scss';

interface Logo {
  name: string;
  file: string;
  // Relative size multiplier applied on top of the shared logo height,
  // for logos whose wordmark otherwise reads visually larger than the rest.
  scale?: number;
}

const logos: Logo[] = [
  { name: 'The Boeing Company', file: 'boeing.png' },
  { name: 'Capgemini', file: 'capgemini.png' },
  { name: 'Pitchspot', file: 'pitchspot.png', scale: 0.7 },
  { name: 'Zone', file: 'zone.svg' },
  { name: 'Antler', file: 'antler.png' },
  { name: 'NUS Enterprise', file: 'nus-enterprise.png' },
  { name: 'Nanyang Business School', file: 'ntu.png' },
  { name: 'National University of Singapore', file: 'nus.png' },
];

const LogoItem: React.FC<{ logo: Logo }> = ({ logo }) => {
  const [failed, setFailed] = useState(false);

  return (
    <span className="marquee__item">
      {failed ? (
        <span className="marquee__fallback">{logo.name}</span>
      ) : (
        <img
          className="marquee__logo"
          src={`/images/logos/${logo.file}`}
          alt={logo.name}
          onError={() => setFailed(true)}
          style={logo.scale ? ({ '--logo-scale': logo.scale } as React.CSSProperties) : undefined}
        />
      )}
      <span className="marquee__bullet">●</span>
    </span>
  );
};

const SkillsMarquee: React.FC = () => {
  const items = [...logos, ...logos];

  return (
    <section className="marquee" aria-label="Experience">
      <div className="marquee__track">
        {items.map((logo, i) => (
          <LogoItem key={i} logo={logo} />
        ))}
      </div>
    </section>
  );
};

export default SkillsMarquee;
